import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { PageOverlay } from '../../components/PageOverlay/styles';
import { StoreState } from '../../reducers';
import { OfflineManagerState } from '../OfflineManager/reducer';
import { AppInfosState } from '../App/reducer';
import { GalleryInfosState } from '../Gallery/reducer';
import { DriveListState } from '../DriveItemList/reducer';
import { DownloadManagerState, DownloadGroupStatus } from '../DownloadManager/reducer';
import { StaleOfflineCleanupState } from './reducer';
import StaleOfflineCleanupContent from '../../components/StaleOfflineCleanupContent';
import { StyledStaleOfflineCleanup } from './styles';
import {
	cleanupStaleOfflineDownloads,
	dismissStaleOfflinePopupForSession,
} from './actions';
import UserAgentUtils from '../../utils/userAgent';
import Utils from '../../utils';
import DownloadManagerUtils from '../../utils/downloadManager';
import DriveItemUtils from '../../utils/driveItem';
import { isStaleOfflineCleanupEnabled } from '../../utils/staleOfflineCleanupConfig';

interface StaleOfflineCleanupProps {
	dispatch: Dispatch<StoreState>;
	appInfos: AppInfosState;
	galleryInfos: GalleryInfosState;
	offlineManager: OfflineManagerState;
	staleOfflineCleanup: StaleOfflineCleanupState;
	downloadAllPopup: { closedByUser: boolean };
	driveList: DriveListState;
	downloadManager: DownloadManagerState;
}

class StaleOfflineCleanup extends React.Component<StaleOfflineCleanupProps> {
	constructor(props: StaleOfflineCleanupProps) {
		super(props);
		this.close = this.close.bind(this);
		this.cleanUp = this.cleanUp.bind(this);
	}

	close() {
		const { dispatch } = this.props;
		dispatch(dismissStaleOfflinePopupForSession());
	}

	cleanUp() {
		const { dispatch } = this.props;
		dispatch(cleanupStaleOfflineDownloads());
	}

	isDownloadAllPopupOpen(): boolean {
		const {
			galleryInfos,
			downloadAllPopup: { closedByUser },
			downloadManager,
			driveList,
		} = this.props;
		const { config } = galleryInfos;
		const { driveItems } = driveList;
		const isEnabled = config && config.downloadAllPopup && config.downloadAllPopup.enabled === true;

		if (!isEnabled || closedByUser) {
			return false;
		}

		const downloadedIds = DownloadManagerUtils.getRequestedItemIds(downloadManager);
		let hasUpdatableDependencies = false;

		for (let index = 0; index < downloadedIds.length; index += 1) {
			const id = downloadedIds[index];

			if (DriveItemUtils.hasUpdatableDependencies(driveItems[id], downloadManager)) {
				hasUpdatableDependencies = true;
				break;
			}
		}

		const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(
			downloadManager,
			driveList,
			galleryInfos,
			[],
		);

		return hasItemsToDownload || hasUpdatableDependencies;
	}

	isDownloadGroupActive(): boolean {
		const { downloadManager: { downloadGroups } } = this.props;

		return downloadGroups.all.status === DownloadGroupStatus.Started
			|| downloadGroups.all.isDownloading
			|| downloadGroups.important.status === DownloadGroupStatus.Started
			|| downloadGroups.important.isDownloading
			|| downloadGroups.selected.status === DownloadGroupStatus.Started
			|| downloadGroups.selected.isDownloading;
	}

	render() {
		const {
			appInfos,
			galleryInfos,
			offlineManager,
			staleOfflineCleanup: { staleIds, dismissedForSession, isCleaningUp, autoCleanEnabled },
			downloadManager,
		} = this.props;
		const isGalleryReady = Utils.isGalleryReady(galleryInfos, offlineManager, appInfos);
		const { isMobileApp } = UserAgentUtils;
		const { isInitReconcileInProgress } = downloadManager;
		const isOnline = UserAgentUtils.isOnline();
		const isFeatureEnabled = isStaleOfflineCleanupEnabled(galleryInfos.config);
		const isPopupOpened = isMobileApp
			&& isOnline
			&& isGalleryReady
			&& isFeatureEnabled
			&& !galleryInfos.forceSplashScreen
			&& staleIds.length > 0
			&& !autoCleanEnabled
			&& !dismissedForSession
			&& !isInitReconcileInProgress
			&& !this.isDownloadGroupActive()
			&& !this.isDownloadAllPopupOpen();

		return (
			<StyledStaleOfflineCleanup>
				<PageOverlay isOpen={isPopupOpened} onClick={this.close} />
				{
					isPopupOpened && <StaleOfflineCleanupContent
						close={this.close}
						cleanUp={this.cleanUp}
						staleCount={staleIds.length}
						isCleaningUp={isCleaningUp}
					/>
				}
			</StyledStaleOfflineCleanup>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const {
		appInfos,
		galleryInfos,
		offlineManager,
		staleOfflineCleanup,
		downloadAllPopup,
		driveList,
		downloadManager,
	} = state;

	return {
		appInfos,
		galleryInfos,
		offlineManager,
		staleOfflineCleanup,
		downloadAllPopup,
		driveList,
		downloadManager,
	};
};

export default connect(mapStateToProps)(StaleOfflineCleanup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaleOfflineCleanup/index.tsx